import React, { useEffect, useState } from 'react'
import { Table, Tab, Row, Col, ListGroup, Button, FormControl, Form, Image } from 'react-bootstrap'
import { RenderImage } from '../presentational-components/ImageViewer'
import moment from 'moment'
import 'moment/locale/de'
import LoadingSpinner from '../presentational-components/LoadingSpinner'
import { FetchBoutiqueInfosArticleTypesForB2COrder, FetchArticleTypeImages } from '../../fetcher'

moment.locale('de')


const NewB2COrder = ({ addTransaction, setNewBooking, designerList, sizeCategories, date, openAlert }) => {
    const controller = new AbortController()
    const signal = controller.signal

    console.log("NewB2COrder");
    console.log(designerList);
    const [designer, setDesigner] = useState(null)
    const [articleType, setArticleType] = useState(null)
    const [sizeCategory, setSizeCategory] = useState(null)

    const [size, setSize] = useState(null)

    let recalculate = () => { }


    const [number, setNumber] = useState(0)
    const [totalPrepayment, setTotalPrepayment] = useState(0)
    const [totalBill, setTotalBill] = useState(0)
    const [remarks, setRemarks] = useState("")
    const [priceChange, setPriceChange] = useState(0)
    const [priceChangeShow, setPriceChangeShow] = useState(0)


    const [prepayment, setPrepayment] = useState(0)
    const [prepaymentShow, setPrepaymentShow] = useState(0)

    const [outstandingBill, setOutstandingBill] = useState(0)

    const [numbersList, setNumbersList] = useState([])

    const [articleTypesList, setArticleTypesList] = useState([])
    const [sizeCategoryList, setSizeCategoryList] = useState([])

    //const [payment, setPayment] = useState(null)

    //date = new Date().toLocaleDateString()
    //const boutique = "Boutique"

    //const [designerList, setDesignerList] = useState([{ DesignerName: "Designer1", DesignerSysId: "1" }, { DesignerName: "Designer2", DesignerSysId: "2" }, { DesignerName: "Designer3", DesignerSysId: "3" }, { DesignerName: "Designer4", DesignerSysId: "4" }, { DesignerName: "Designer5", DesignerSysId: "5" }])
    //const dummySizeList = ["SizeA", "SizeB", "SizeC", "SizeD", "SizeE"]
    //const [articleTypeList, setArticleTypeList] = useState(
    //[
    //    { ArticleTypeName: "ArticleName1", ArticleTypeSysId: "ArticleSysId1", DesignerSysId: "1", Sizes: dummySizeList, PriceUnit: 9.99 },
    //    { ArticleTypeName: "ArticleName2", ArticleTypeSysId: "ArticleSysId2", DesignerSysId: "1", Sizes: dummySizeList, PriceUnit: 7.99 },
    //    { ArticleTypeName: "ArticleName3", ArticleTypeSysId: "ArticleSysId3", DesignerSysId: "2", Sizes: dummySizeList, PriceUnit: 29 },
    //    { ArticleTypeName: "ArticleName4", ArticleTypeSysId: "ArticleSysId4", DesignerSysId: "2", Sizes: dummySizeList, PriceUnit: 40 },
    //    { ArticleTypeName: "ArticleName5", ArticleTypeSysId: "ArticleSysId5", DesignerSysId: "3", Sizes: dummySizeList, PriceUnit: 42.79 }])

    //const dummyNumbersList= [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]

    const [articleDataReady, setArticleDataToReady] = useState(false)

    const addingImages = (articleTypeImages) => {
        let copiedArticleTypesList = [...articleTypesList]
        articleTypeImages.forEach(image => copiedArticleTypesList.filter(x => x.ArticleTypeSysId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setArticleTypesList(copiedArticleTypesList)
    }

    useEffect(() => {
        if (articleDataReady) {
            FetchArticleTypeImages(articleTypesList.map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    useEffect(() => {
        if (priceChange != undefined && priceChange != null && prepayment != undefined && prepayment != null && articleType != undefined && articleType != null && outstandingBill != undefined && outstandingBill != null) {
            recalculateInternal()
        }
    }, [number, priceChange, prepayment])

    useEffect(() => {
        if (articleType != undefined && articleType != null)
            setPriceAtTimeOfOrdering(articleType.PriceUnit)
    }, [articleType])

    const [priceAtTimeOfOrdering, setPriceAtTimeOfOrdering] = useState(articleType != undefined && articleType != null ? articleType.PriceUnit : 0)


    const handleSizeChange = (e, sizeToSet) => {
        e.preventDefault()

        console.log("handleSizeChange")
        console.log(sizeToSet)

        setSize({ "Size" : sizeToSet, "Amount" : 5 })
        //let amount = (articleType.Sizes.find(x => x.Size == sizeToSet.Size).Amount)
        let amounts = []
        //for (let i = 1; i <= amount; i++) {
        //    amounts.push(i)
        //}
        for (let i = 1; i <= 5; i++) {
            amounts.push(i)
        }

        setNumbersList(amounts)
    }

    const handleSizeCategoryChange = (e, sizeCategoryToSet) => {
        e.preventDefault()

        setSizeCategory(sizeCategoryToSet)
        articleType.Sizes = sizeCategoryToSet.Sizes
        //let amount = (articleType.Sizes.find(x => x.Size == sizeToSet.Size).Amount)
        let amounts = []
        //for (let i = 1; i <= amount; i++) {
        //    amounts.push(i)
        //}
        for (let i = 1; i <= 5; i++) {
            amounts.push(i)
        }

        setNumbersList(amounts)
    }

    const handleSubmit = () => {
        const newTransaction = {
            designer: designer,
            articleType: articleType,
            sizeCategory: sizeCategory,
            size: size,
            number: number,
            total: totalBill,
            priceChange: priceChange,
            prepayment: prepayment,
            remarks: remarks,
            priceAtTimeOfOrdering: priceAtTimeOfOrdering
        }

        console.log("NewB2COrderSubmit")
        console.log(newTransaction)

        addTransaction(newTransaction)
        setNewBooking(false)
    }

    const [designerFilterInput, setDesignerFilterInput] = useState("")
    const handleDesignerFilter = (e) => {
        setDesignerFilterInput(e.target.value)
    }

    const [articleTypeFilterInput, setArticleTypeFilterInput] = useState("")
    const handleArticleTypeFilter = (e) => {
        setArticleTypeFilterInput(e.target.value)
    }

    const [sizeFilterInput, setSizeFilterInput] = useState("")
    const handleSizeFilter = (e) => {
        setSizeFilterInput(e.target.value)
    }

    const [numberFilterInput, setNumberFilterInput] = useState("")
    const handleNumberFilter = (e) => {
        setNumberFilterInput(e.target.value)
    }

    const selectNumber = (value) => {
        setNumber(value)
        recalculate = () => recalculateInternal()
    }

    const selectPriceChange = (value) => {
        console.log("selectPriceChangeselectPriceChangeselectPriceChangeselectPriceChangeselectPriceChangeselectPriceChange")
        console.log(value, parseFloat(value), priceChange, outstandingBill)
        let newValue = value.toString().replace(',', '.')
        console.log(newValue)
        console.log(newValue, parseFloat(newValue), priceChange, outstandingBill)
        setPriceChangeShow(newValue)
        let newValueParsed = parseFloat(newValue)
        console.log(newValueParsed, newValueParsed.toFixed(2).toString().length, newValueParsed.toString().length)
        if (!isNaN(newValueParsed)) {
            setPriceChange(newValueParsed.toFixed(2))
            setPriceChangeShow(newValueParsed.toFixed(2).toString().length < newValueParsed.toString().length ? newValueParsed.toFixed(2) : newValueParsed)
            setPriceAtTimeOfOrdering(priceAtTimeOfOrdering)
        }
        else
            setPriceChange(0)
    }

    const selectPrepayment = (value) => {
        console.log("selectPrepayment")
        console.log(value, parseFloat(value), priceChange, outstandingBill)
        let newValue = value.toString().replace(',', '.')
        console.log(newValue)
        console.log(newValue, parseFloat(newValue), priceChange, outstandingBill)
        let newValueParsed = parseFloat(newValue)
        console.log(newValueParsed, newValueParsed.toFixed(2).toString().length, newValueParsed.toString().length)
        if (!isNaN(newValueParsed)) {
            console.log("selectPrepaymentselectPrepaymentselectPrepaymentselectPrepaymentselectPrepaymentselectPrepaymentselectPrepaymentselectPrepaymentselectPrepaymentselectPrepaymentselectPrepaymentselectPrepayment")

            setPrepaymentShow(newValueParsed.toFixed(2).toString().length < newValueParsed.toString().length ? newValueParsed.toFixed(2) : newValueParsed)
            setPrepayment(newValueParsed.toFixed(2))

            console.log("selectPrepayment 1.1 " + newValueParsed.toFixed(2).toString() + " " +  newValueParsed.toString())

        }
        else if (value == "") {
            console.log("selectPrepayment 2")
            setPrepaymentShow("")
            setPrepayment(0)
        }
    }

    const selectRestBill = (value) => {
        console.log("selectRestBill")
        setTotalBill(value)
        setTotalPrepayment(value * number)
    }

    const handleSetDesigner = (designer) => {
        FetchBoutiqueInfosArticleTypesForB2COrder(designer.DesignerSysId, setArticleTypesList, setSizeCategoryList, openAlert, setArticleDataToReady, signal, "", 5)
        setDesigner(designer)
    }

    const recalculateInternal = () => {
        console.log("recalculaterecalculaterecalculaterecalculaterecalculaterecalculaterecalculaterecalculaterecalculate")
        if (outstandingBill === 0)
            console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX")
        let priceUnit = parseFloat(articleType.PriceUnit)
        let priceChageFl = parseFloat(priceChange)
        if (priceChageFl == undefined || priceChageFl == null)
            priceChageFl = 0
        else
            if (priceChageFl + priceUnit < 0) {
                priceChageFl = -1 * priceUnit
                setPriceChange(priceChageFl)
                setPriceChangeShow(priceChageFl)
            }
        let prepaymentFl = parseFloat(prepayment)
        if (prepaymentFl == undefined || prepaymentFl == null || prepaymentFl < 0)
            prepaymentFl = 0
        console.log(priceUnit, priceChageFl, prepaymentFl, prepaymentShow, prepayment, outstandingBill)
        if (!isNaN(priceUnit + priceChageFl - prepaymentFl) && prepaymentFl > priceUnit + priceChageFl) {
            prepaymentFl = priceUnit + priceChageFl
        }
        if (!isNaN(priceUnit + priceChageFl - prepaymentFl)) {
            console.log(priceUnit + priceChageFl - prepaymentFl, outstandingBill)
            setOutstandingBill(priceUnit + priceChageFl - prepaymentFl)
            console.log(priceUnit + priceChageFl - prepaymentFl, outstandingBill)
            setTotalBill((priceUnit + priceChageFl - prepaymentFl) * number)

            if (prepaymentShow !== "") {
                    setPrepaymentShow(prepaymentFl)
                    setPrepayment(prepaymentFl)
            }
            setTotalPrepayment(prepaymentFl * number)
            setPriceAtTimeOfOrdering(priceUnit + priceChageFl)
            console.log(prepayment, totalPrepayment)
            console.log(priceUnit + priceChageFl - prepaymentFl, prepayment, totalPrepayment)
        }
        else {
            setPriceAtTimeOfOrdering(articleType.PriceUnit)
            if (prepayment !== "") {
                setPrepaymentShow(prepaymentFl)
                setPrepayment(prepaymentFl)
            }
        }

    }

    const ChooseDesigner = () => {
        return (
            <div className="designerList">
                <Col className="designer-col" >
                    <FormControl className="globalSearch-booking" as="input" placeholder="Name Designer..." value={designerFilterInput} onChange={handleDesignerFilter}></FormControl>
                    <ListGroup className="listGroup" >
                        {designerList.sort((a, b) => a.DesignerName.localeCompare(b.DesignerName)).filter(x => x.DesignerName.toLowerCase().includes(designerFilterInput.toLowerCase())).map(designer =>
                            <ListGroup.Item value={designer.DesignerName} action onClick={(e) => handleSetDesigner(designer)}>
                                {designer.DesignerName}
                            </ListGroup.Item>
                        )}
                    </ListGroup>
                    {designerList.length === 0 ? "Designer werden geladen..." : ""}
                </Col>
            </div>
        )
    }

    const ChooseArticleType = () => {
        return (
            <div className="">
                <Button variant="light" onClick={() => setDesigner(null)}>{designer.DesignerName}</Button>
                <Col className="booking-articleType">
                    <FormControl className="globalSearch-booking" as="input" placeholder="Artikeltyp..." value={articleTypeFilterInput} onChange={handleArticleTypeFilter}></FormControl>
                    <div className="blocky">
                        <ListGroup className="listGroup" >
                            {articleTypesList.sort((a, b) => a.ArticleTypeName.localeCompare(b.ArticleTypeName)).filter(x => x.DesignerSysId == designer.DesignerSysId)
                                .filter(x => x.ArticleTypeName.toLowerCase().includes(articleTypeFilterInput.toLowerCase())
                                    || x.ArticleIdFaex.toLowerCase().includes(articleTypeFilterInput.toLowerCase())
                                    || x.Colour.toLowerCase().includes(articleTypeFilterInput.toLowerCase())
                                    || x.ArticleNumberDesigner.toLowerCase().includes(articleTypeFilterInput.toLowerCase())
                                    || parseFloat(x.PriceUnit).toFixed(2).replace('.', ',').toString().includes(articleTypeFilterInput.toLowerCase())
                                ).map(articleType =>
                                    <div >
                                        <ListGroup.Item className="listGroup-item" value={articleType.ArticleTypeName} action onClick={(e) => { console.log("ChooseArticleType"); console.log(e); console.log(e.SizeCategory); articleType.ArticleTypeSysId !== "00000000-0000-0000-0000-000000000000" ? setSizeCategory(articleType.SizeCategory) : setSizeCategory(null); setArticleType(articleType); }}>

                                            <Row className="nowrap">

                                                <Col className="dropdown-imageColumn">{RenderImage(articleType.Image)}</Col>
                                                <Col className="dropdown-article-smallField">{articleType.ArticleIdFaex}</Col>
                                                <Col className="dropdown-article">{articleType.ArticleNumberDesigner}</Col>
                                                <Col className="dropdown-article-smallField">{articleType.Colour}</Col>
                                                <Col className="dropdown-article-smallField dropdown-article-currency">{parseFloat(articleType.PriceUnit).toFixed(2).replace('.', ',') + "€"}</Col>
                                                <Col>{articleType.ArticleTypeName}</Col>

                                            </Row>

                                        </ListGroup.Item>
                                    </div>
                                )}
                        </ListGroup>
                    </div>
                </Col>
            </div>
        )
    }

    const ChooseSizeCategory = () => {
        return (
            <div className="">
                <Row>
                    <Col className="booking-size">
                        <Button variant="light" onClick={() => { setArticleType(null); setDesigner(null) }}>{designer.DesignerName}</Button>
                        <Button variant="light" onClick={() => setArticleType(null)}>{articleType.ArticleTypeName}</Button>
                        <FormControl className="globalSearch-booking listGroup-small" as="input" placeholder="Größe..." value={sizeFilterInput} onChange={handleSizeFilter}></FormControl>
                        <ListGroup className="listGroup listGroup-small" >
                            {sizeCategoryList.filter(x => x.Name.toLowerCase().includes(sizeFilterInput.toLowerCase())).map(sizeCategory =>
                                <ListGroup.Item value={sizeCategory.Name} action onClick={(e) => handleSizeCategoryChange(e, sizeCategory)}>
                                    {sizeCategory.Name}
                                </ListGroup.Item>
                            )}
                        </ListGroup>
                    </Col>
                    <Col className="imageColumn-sale">
                        <Image className="fullimage-small" src={articleType.Image} />
                    </Col>
                </Row>
            </div>
        )
    }

    const ChooseSize = () => {
        console.log("ChooseSize");
        console.log(sizeCategory);
        return (
            <div className="">
                <Row>
                    <Col className="booking-size">
                        <Button variant="light" onClick={() => { setSizeCategory(null); setArticleType(null); setDesigner(null) }}>{designer.DesignerName}</Button>
                        <Button variant="light" onClick={() => { setSizeCategory(null); setArticleType(null) }}>{articleType.ArticleTypeName}</Button>
                        {articleType.ArticleTypeSysId == "00000000-0000-0000-0000-000000000000" ? < Button variant="light" onClick={() => { setSizeCategory(null) }}>{sizeCategory.Name}</Button> : <></>}
                        <FormControl className="globalSearch-booking listGroup-small" as="input" placeholder="Größe..." value={sizeFilterInput} onChange={handleSizeFilter}></FormControl>
                        <ListGroup className="listGroup listGroup-small" >
                            {sizeCategory.Values.filter(x => x.toLowerCase().includes(sizeFilterInput.toLowerCase())).map(size =>
                                <ListGroup.Item value={size} action onClick={(e) => handleSizeChange(e, size)}>
                                    {size}
                                </ListGroup.Item>
                            )}
                        </ListGroup>
                    </Col>
                    <Col className="imageColumn-sale">
                        <Image className="fullimage-small" src={articleType.Image} />
                    </Col>
                </Row>
            </div>
        )
    }

    const ChooseNumber = () => {
        return (
            <div className="">
                <Row>
                    <Col className="booking-number">
                        <Button variant="light" onClick={() => { setSize(null); setSizeCategory(null); setArticleType(null); setDesigner(null) }}>{designer.DesignerName}</Button>
                        <Button variant="light" onClick={() => { setSize(null); setSizeCategory(null); setArticleType(null) }}>{articleType.ArticleTypeName}</Button>
                        {articleType.SizeCategory != undefined ? < Button variant="light" onClick={() => { setSize(null); setSizeCategory(null) }}>{articleType.SizeCategory.Name}</Button> : ""}
                        <Button variant="light" onClick={() => setSize(null)}>{size.Size}</Button>
                        Bestellbarer Anzahl: {numbersList.length}

                        <FormControl className="globalSearch-booking listGroup-small" as="input" placeholder="Anzahl..." value={numberFilterInput} onChange={handleNumberFilter}></FormControl>
                        <ListGroup className="listGroup listGroup-small" >
                            {numbersList.filter(x => x.toString().includes(numberFilterInput)).map(number =>
                                <ListGroup.Item value={number} action onClick={(e) => selectNumber(e.target.value)}>
                                    {number}
                                </ListGroup.Item>
                            )}
                        </ListGroup>
                    </Col>
                    <Col className="imageColumn-sale">
                        <Image className="fullimage-small" src={articleType.Image} />
                    </Col>
                </Row>
            </div>
        )
    }

    const Checkout = () => {
        console.log("Checkout")
        console.log(articleType)
        console.log(prepayment)
        console.log(sizeCategory)
        console.log(size)

        return (
            <div>
                <Row className="checkout-row">

                    <Row>
                        <Col>
                            <Button variant="light" className="" onClick={() => { setDesigner(null); setArticleType(null); setSizeCategory(null); setSize(null); setNumber(0); setTotalPrepayment(0) }}>{designer.DesignerName}</Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="first-column">
                            <Button variant="light" className="" onClick={() => { setArticleType(null); setSizeCategory(null); setSize(null); setNumber(0); setTotalPrepayment(0) }}>{articleType.ArticleTypeName}</Button>
                            {articleType.ArticleTypeSysId == "00000000-0000-0000-0000-000000000000" ? <Button variant="light" className="" onClick={() => { setSizeCategory(null); setSize(null); setNumber(0); setTotalPrepayment(0) }}>{sizeCategory.Name}</Button> : <></>}
                            <Button variant="light" className="" onClick={() => { setSize(null); setNumber(0); setTotalPrepayment(0) }}>{size.Size}</Button>
                            <Button variant="light" className="" onClick={() => { setNumber(0); setTotalPrepayment(0) }}>{number}</Button>
                            <Button variant="light" disabled className="">{parseFloat(articleType.PriceUnit).toFixed(2).replace('.', ',') + "€"}</Button>

                            <Form className="main-form">
                                <Row>
                                    <Form.Group>
                                        <Form.Label className="form label">Preiseänderung:</Form.Label>
                                        <FormControl className="form currency-input" value={priceChangeShow} type="number" step=".01"
                                            onChange={(e) => selectPriceChange(e.target.value)} size="md" md="auto"/>

                                        <Form.Label>Endpreis:</Form.Label>
                                        <Button variant="light" disabled className="">{(parseFloat(priceAtTimeOfOrdering)).toFixed(2).replace('.', ',') + "€"}</Button>
                                    </Form.Group>
                                </Row>
                                <Row>
                                     <Form.Group>
                                        <Form.Label className="form label">Anzahlung pro Artikel:</Form.Label>
                                        <FormControl className="form currency-input" value={prepaymentShow} type="number" step=".01"
                                            onChange={(e) => selectPrepayment(e.target.value)} size="md" />

                                        <Form.Label>Anzahlung insgesamt:</Form.Label>
                                        <Button variant="light" disabled className="">{parseFloat(totalPrepayment).toFixed(2).replace('.', ',') + "€"}</Button>
                                     </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group>
                                        <Form.Label className="form label">Restzahlung pro Artikel:</Form.Label>
                                        <FormControl className="form currency-input" disabled value={outstandingBill} type="number" step=".01"
                                            onChange={(e) => selectRestBill(e.target.value)} size="md" />

                                        <Form.Label>Restzahlung insgesamt:</Form.Label>
                                        <Button variant="light" disabled className="">{parseFloat(totalBill).toFixed(2).replace('.', ',') + "€"}</Button>
                                    </Form.Group>
                                </Row>
                                </Form>
                        </Col>
                    </Row>


                    <Col className="imageColumn-sale">
                        <Image className="fullimage-small" src={articleType.Image} />
                    </Col>
                    <Col>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label className="form remark">Bemerkung</Form.Label><> </>
                                {articleType.ArticleTypeSysId != undefined && articleType.ArticleTypeSysId != null ? articleType.ArticleTypeSysId == "00000000-0000-0000-0000-000000000000" ? <Form.Label className="form remark" style={{ color: 'red' }}>(Pflichfeld, mind. 20 Symbole)</Form.Label> : <Form.Label className="form remark"> (optional)</Form.Label> : <></>} 
                                <Form.Control as="textarea" rows={8} onChange={(e) => setRemarks(e.target.value)} placeholder={articleType.ArticleTypeSysId == undefined || articleType.ArticleTypeSysId == null || articleType.ArticleTypeSysId == "00000000-0000-0000-0000-000000000000" ? "Bitte bescreiben Sie den gewünschten Artikel detailiert wie möglich." : ""} />
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>

                {/*<Row className="checkout-row">*/}
                {/*    <Col sm="4">*/}
                {/*        <FormControl as="select" onChange={(e) => setPayment(e.target.value)}>*/}
                {/*            <option defaultValue selected disabled>Zahlungsmittel</option>*/}
                {/*            {dummyPaymentList.map(payment =>*/}
                {/*                <option>{payment}</option>*/}
                {/*            )}*/}
                {/*        </FormControl>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*<Button variant="success" className="">&#43; Neu</Button>*/}
            </div>
        )
    }

    const reset = () => {
        setDesigner(null)
        setArticleType(null)
        setSize(null)
        setNumber(0)
        setTotalPrepayment(0)
    }

    return (
        <div >
            { console.log("render")}{console.log(prepayment)}{console.log((number === null || number === 0 || prepayment === null || prepayment == 0 || (articleType.ArticleTypeSysId == "00000000-0000-0000-0000-000000000000" && (remarks === null || remarks.length < 20))))}
            <h1 className="tablet-center">Bestellung buchen</h1>
            <div className="flex-linebreak"></div>

            <div className="tablet-transactions">
                <Table>
                    <thead>
                        <th>{moment(date).format("DD.MM.YYYY")}</th>
                        {/*<th>{boutique}</th>*/}
                        {/*<th>{payment !== null ? payment : "Zahlung"}</th>*/}
                        <th>{number !== 0 ? number : "Anzahl"}</th>
                        <th>{parseFloat(totalPrepayment).toFixed(2).replace('.', ',') + "€"}</th>
                    </thead>
                </Table>
                <div>

                    {designer === null
                        ? ChooseDesigner()
                        : articleType === null
                            ? ChooseArticleType()
                            : sizeCategory === null
                                ? ChooseSizeCategory()
                                : size === null
                                    ? ChooseSize()
                                    : number === 0
                                        ? ChooseNumber()
                                        : Checkout()}

                </div>
                <div className="bookingButtons">
                    <Button variant="secondary" onClick={() => { reset(); setNewBooking(false) }}>Abbrechen</Button>
                    <Button variant="secondary" disabled={(number == null || number == 0 || (articleType.ArticleTypeSysId == "00000000-0000-0000-0000-000000000000" && (remarks == null || remarks.length < 20))) ? true : false} onClick={handleSubmit}>Buchen</Button>
                </div>
            </div>
        </div>
    )
}

export default NewB2COrder

